<script lang="ts">
import type { MaybeComputedElementRef } from "@vueuse/core";
import type { VariantProps } from "class-variance-authority";
import type { InputTypeHTMLAttribute } from "vue";
import type { TextInputBaseProps } from "./textInputBase";
import type { TextFieldAutosProps } from "./useTextFieldAutos";
import { cva, cx } from "class-variance-authority";
import { useForwardExpose } from "reka-ui";
import { textInputBase } from "./textInputBase";
import { useTextFieldAutos } from "./useTextFieldAutos";

const base = cva(["whitespace-nowrap"], {
  variants: {},
});
type TextFieldBaseProps = VariantProps<typeof base>;

export type TextFieldProps = TextInputBaseProps & TextFieldBaseProps;
const textField = (tfProps: TextFieldProps) => cx(textInputBase(tfProps), base(tfProps));
</script>

<script setup lang="ts">
const props = defineProps<{
  type?: InputTypeHTMLAttribute;
  variant?: TextFieldProps["variant"];
  size?: TextFieldProps["size"];
  disabled?: boolean;
  disableAssistants?: boolean;
} & TextFieldAutosProps>();

const value = defineModel<string>();
const { forwardRef, currentRef } = useForwardExpose();

useTextFieldAutos(currentRef as MaybeComputedElementRef<HTMLInputElement>, {
  autofocus: () => props.autofocus,
  autoselect: () => props.autoselect,
});
</script>

<template>
  <input
    :ref="forwardRef"
    v-model="value"
    :type="type"
    :disabled="disabled"
    :autocapitalize="disableAssistants ? 'none' : undefined"
    :autocomplete="disableAssistants ? 'off' : undefined"
    :autocorrect="disableAssistants ? 'off' : undefined"
    :spellcheck="disableAssistants ? 'false' : undefined"
    :class="textField({ variant, size })"
  />
</template>
